import React, {useState, useRef} from "react";
import css from "./index.module.scss";
import Card from "@/components/card";
import SplitText from "@/components/splitText";
import { useInView } from "react-intersection-observer";
import inViewSettings from "scripts/animations/inViewSettings";
import slideFadeIn from "scripts/animations/slideFadeIn";
import popFadeIn from "scripts/animations/popFadeIn";

export default function BasicCardSection({
  headline = "",
  subheadline = "",
  width = "3",
  color = "green",
  cards = [
    {
      name: "Youtube Influencer Marketing",
      body: "In-depth product reviews and tutorials work well on YouTube, while short social content may get lost; be prepared to make a sizable investment of hundreds to tens-of-thousands per video for this premium platform.",
    },
  ],
}) {
  const [elements, setElements] = useState({
    text: useInView(inViewSettings(slideFadeIn)),
    cards: useInView(inViewSettings(popFadeIn)),
  });

  let cardDark = false;

  if (color === "purple" || color === "blue") {
    cardDark = true;
  }

  return <section className={`section ${css.cards}`} style={{"--width": width, "--color": `var(--${color})`}}>
    <div className="sectionInner" >
      <div ref={elements.text.ref}>
        <h2>
          <SplitText className="target" text={headline}/>
        </h2>
        <div className={css.subheadline}>
          <SplitText className="target" text={subheadline}/>
        </div>
      </div>

      <div className={css.cards} ref={elements.cards.ref}>
        {cards.map((card) => <Card dark={cardDark} className={`target ${css.card}`} headline={card.name} key={card.name}>
          <div className={css.cardInner}>{card.body}</div>
        </Card>)}
      </div>
    </div>
  </section>;
}



